<script lang="ts">
  import type { EChartsCoreOption } from 'echarts/core';
  import type { SeriesResult } from '../data/types';
  import { formatCents } from '../presentation/format';
  import Chart from './Chart.svelte';
  import { dimensionColor } from './dimension-colors';

  let {
    title,
    description,
    option,
    result,
    height = '20rem',
  }: {
    title: string;
    description: string;
    option: EChartsCoreOption;
    result: SeriesResult;
    height?: string;
  } = $props();
  let showData = $state(false);
</script>

<section class="card chart-card">
  <header class="card-header">
    <div>
      <h2>{title}</h2>
      <p class="muted">{description}</p>
    </div>
    <button
      class="text-button"
      type="button"
      aria-expanded={showData}
      onclick={() => (showData = !showData)}
    >
      {showData ? 'Nascondi dati' : 'Mostra dati'}
    </button>
  </header>
  <Chart {option} ariaLabel={`${title}. ${description}`} {height} />
  {#if showData}
    <!-- svelte-ignore a11y_no_noninteractive_tabindex (scrollable region must be keyboard reachable) -->
    <div
      class="data-view scroll-region"
      tabindex="0"
      role="region"
      aria-label={`Dati tabellari: ${title}`}
    >
      <table>
        <thead
          ><tr
            ><th>Periodo</th>{#each result.series as series}<th
                ><span
                  class="data-series-label"
                  style={`--dimension-color: ${dimensionColor(series.colorKey ?? `series:${series.id}`, series.label)}`}
                  >{series.label}</span
                ></th
              >{/each}</tr
          ></thead
        >
        <tbody>
          {#each result.buckets as bucket, index}
            <tr
              ><th>{bucket}</th>{#each result.series as series}<td
                  >{result.unit === 'count'
                    ? series.values[index]
                    : formatCents(series.values[index] ?? 0)}</td
                >{/each}</tr
            >
          {/each}
        </tbody>
      </table>
    </div>
  {/if}
</section>
